import { render } from "./Tal_gMainHeader.vue?vue&type=template&id=6eafd044"
import script from "./Tal_gMainHeader.vue?vue&type=script&lang=js"
export * from "./Tal_gMainHeader.vue?vue&type=script&lang=js"

import "./Tal_gMainHeader.vue?vue&type=style&index=0&id=6eafd044&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__